import React, { useState } from "react";
import { ReactComponent as AddIcon } from "../../../../assets/icons/add-circle.svg";
import Button from "../../components/Button";
import DatePicker from "../../components/DatePicker";
import SearchInput from "../../components/SearchInput";

const FilterBar = ({
  search,
  setSearch,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  handleSearch,
}) => {
  const [openPicker, setOpenPicker] = useState(null);

  const handleDatePickerToggle = (picker) => {
    setOpenPicker((prev) => (prev === picker ? null : picker));
  };

  const handleFromDateChange = (newFromDate) => {
    if (!toDate) {
      setFromDate(newFromDate);
      return;
    }
    const to = toDate ? new Date(toDate.split("-").reverse().join("-")) : null;
    const from = new Date(newFromDate.split("-").reverse().join("-"));

    if (to && from > to) {
      alert("⚠️ Ngày bắt đầu không được lớn hơn ngày kết thúc.");
      return;
    }

    setFromDate(newFromDate);
  };

  const handleToDateChange = (newToDate) => {
    if (!fromDate) {
      setToDate(newToDate);
      return;
    }

    const from = fromDate
      ? new Date(fromDate.split("-").reverse().join("-"))
      : null;
    const to = new Date(newToDate.split("-").reverse().join("-"));

    if (from && to < from) {
      alert("⚠️ Ngày kết thúc không được nhỏ hơn ngày bắt đầu.");
      return;
    }

    setToDate(newToDate);
  };

  return (
    <div className="mb-4 flex items-center justify-between gap-3">
      {/* LEFT GROUP - Search + DatePickers + Apply Button */}
      <div className="flex items-center gap-3">
        {/* Search Input */}
        <SearchInput
          value={search}
          placeholder="Tìm kiếm yêu cầu"
          onChange={(event) => setSearch(event.target.value)}
          onSearch={handleSearch}
          className="w-[280px]"
        />

        {/* Date Pickers Group */}
        <div className="flex items-center gap-3">
          {/* From Date Picker */}
          <div className="w-full min-w-[200px] max-w-[200px]">
            <DatePicker
              placeholder="Từ ngày"
              initValue={fromDate}
              height="42px"
              onChange={handleFromDateChange}
              isCalendarOpen={openPicker === "fromDate"}
              onToggle={() => handleDatePickerToggle("fromDate")}
            />
          </div>

          {/* To Date Picker */}
          <div className="w-full min-w-[200px] max-w-[200px]">
            <DatePicker
              placeholder="Đến ngày"
              initValue={toDate}
              height="42px"
              onChange={handleToDateChange}
              isCalendarOpen={openPicker === "toDate"}
              onToggle={() => handleDatePickerToggle("toDate")}
            />
          </div>
        </div>

        {/* Apply Button */}
        <Button
          type="button"
          variant="primary"
          size="lg"
          onClick={handleSearch}
          aria-label="Áp dụng bộ lọc"
        >
          Áp dụng
        </Button>
      </div>

      {/* RIGHT GROUP - Create New Button */}
      <Button
        type="button"
        variant="primary"
        size="lg"
        onClick={() => {
          window.location = "/danh-sach-yeu-cau/them-moi";
        }}
        aria-label="Tạo mới"
        leftIcon={<AddIcon />}
      >
        Tạo mới
      </Button>
    </div>
  );
};

export default FilterBar;
